import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../_app";
import { employeeRouteMap, isEmployeeRoute, isValidEmployeeRoute, openRoute, routeMap, routeMapWrite } from "../utils/routes";
import { Notify } from "../utils";

const ProtectedRoute = (props: any) => {
  const { children } = props;
  let { pathname } = useLocation();
  const user = useAppSelector((state) => state.user);

  let isEmployee = user?.isEmployee || false;

  // Handle employee-specific routing
  if (isEmployee) {
    if (!isValidEmployeeRoute(pathname)) {
      console.log("Invalid employee route:", pathname);
      // Route doesn't exist for employees, return children to let router handle 404
      return children;
    }
    
    const hasEmployeeAccess = isEmployeeRoute(pathname);
    if (!hasEmployeeAccess) {
      Notify("Access denied. You don't have permission to access this page.", 0);
      return <Navigate to="/dashboard/access-denied" />;
    }
  }

  if (pathname.includes("RegularInputItemsAddField")) {
    pathname = "/dashboard/RegularInputItemsAddField";
  } else if (pathname.includes("EmployeePayslipAddField")) {
    pathname = "/dashboard/EmployeePayslipAddField";
  }

  const routeValue = routeMap[pathname];
  const writeRouteValue = routeMapWrite[pathname];
  const isOpenRoute = openRoute.includes(pathname);
  const employeeRouteValue = isEmployee ? employeeRouteMap[pathname] : null;

  console.log("employeeRouteValue", pathname, employeeRouteMap[pathname], isEmployee);

  let isAccessible = user?.permission !== "none" || pathname === "/dashboard/user-profile";

  console.log("isAccessible out beforeAllChecks", isAccessible, user?.permission, pathname, employeeRouteValue );
  if (isAccessible) {
    console.log("isAccessible inside", isAccessible, user?.permission, employeeRouteValue );
    if (user?.permission === "read") {
      isAccessible =
        isOpenRoute ||
        user?.menu?.includes(routeValue) ||
        pathname === "/dashboard/user-profile" ||
        pathname === "/";
    } else if (user?.permission === "full") {
      console.log("isAccessible inside FULL", isAccessible, user?.permission, employeeRouteValue );
      console.log("BEFORE CHECK ROUTE", routeValue, pathname, employeeRouteValue);
      console.log("BEFORE CHECK", user?.menu?.includes(routeValue), user?.menu?.includes(writeRouteValue), isOpenRoute, );
      console.log("BEFORE CHECK Employee", user?.menu?.includes(employeeRouteValue), employeeRouteValue);
      isAccessible =
        isOpenRoute ||
        user?.menu?.includes(routeValue) ||
        user?.menu?.includes(writeRouteValue) ||
        // user?.menu?.includes(employeeRouteValue) ||
        pathname === "/dashboard/user-profile" ||
        pathname === "/";

      console.log("isAccessible inside AFTER", isAccessible, user?.permission );
    }


    if(isEmployee) {
      isAccessible = isOpenRoute || user?.menu?.includes(employeeRouteValue) || pathname === "/";
    }

    
  }

  if (!isAccessible && user?.email !== "") {
    console.log("isAccessible Toast", {
        isAccessible: isAccessible,
        pathname: pathname,
        permission: user?.permission,
        notNone: user?.permission !== "none",
        routeValue: routeValue,
        writeRouteValue: writeRouteValue,
        isOpenRoute: isOpenRoute,
        employeeRouteValue: employeeRouteValue,
        user: user,
        menuHasRoute: user?.menu?.includes(routeValue),
        menuHasWriteRoute: user?.menu?.includes(writeRouteValue),
        menuHasEmployeeRoute: user?.menu?.includes(employeeRouteValue),
      } );
    Notify(
      "You do not have access to perform this operation. Contact your manager for access. You are redirected to User profile page for now",
      0
    );
  }

  console.log("isAccessible before Navigatiing to 403", {
    isAccessible: isAccessible,
    pathname: pathname,
    permission: user?.permission,
    notNone: user?.permission !== "none",
    routeValue: routeValue,
    writeRouteValue: writeRouteValue,
    isOpenRoute: isOpenRoute,
    employeeRouteValue: employeeRouteValue,
  } );



  return isAccessible ? children : <Navigate to="/dashboard/access-denied" />;
};

export default ProtectedRoute;
